module.exports = {
    home: {
        'tab1': '常用食材',
        'tab2': 'TOP榜',
        'tab3': '名廚菜譜',
        'tab4': '推薦',
        'msg1': '住家飯由新鮮食材+智能烹飪機現場制做',
        'more': '更多體驗店'
    },
    tips: {
        'no_data': '沒有數據',
        'loading': '加載中',
        'shareMsg': '請點擊右上角，使用瀏覽器打開', 
        'searchMsg': '輸入門店或者地址關鍵字',
        'keywords': '關鍵詞',
        'data': '數據',
        'jie': '結',
        'long': '沒有更多的數據了',
        'delete': '確定要刪除嗎？',
        'noSearch': '沒有搜索結果',
        'no': '暫無',
        'collect': '確定要取消收藏嗎？',
        'confirm': '確認',
        'confirm1': '確定',
        'connect': '聯繫',
        'detail': '明細',
        'oneMore': '再來一單'
    },
    shop: {
        'settlement': '去結算',
        'sendPay': '配送費',
        'short': '還差',
        'send1': '送貨到家',
        'send2': '到店自取',
        'isReady':'凈菜已經準備好了，請到門店自取',
        'msg1': '選擇本服務則默認閱讀並同意',
        'msg2': '用戶到店自取授權協議',
        'packet': '紅包',
        'coupon': '優惠券',
        'chose': '選擇',
        'getPacket': '去領紅包',
        'getCoupon': '去領優惠券',
        'shopCoupon': '店鋪優惠券',
        'title1': '優惠卡包',
        'getPack': '領紅包',
        'getCoup': '領優惠券',
        'businessHours': '營業時間',
        'msg3': '請在營業時間內到店自取，不提供隔天取貨服務',
        'store': '店鋪',
        'msg4': '本單將由以下店鋪負責配送',
        'storeName': '店鋪名稱',
        'msg5': '店鋪已暫停營業',
        'welcome': '歡迎',
        'pleaceChose': '請選擇',
        'sendTime': '送達時間',
        'expect': '預計',
        'time': '時間',
        'orderTime': '下單時間',
        'phone': '預留電話',
        'msg6': '選擇地址後使用優惠券',
        'msg7': '選擇地址後使用紅包',
        'msg8': '現時間晚於自取可選時間，無法到店自取',
        'msg9': '請輸入正確的手機號',
        'msg10': '距離自取時間小於10分鐘，請重新選擇時間',
        'msg11': '請選擇收貨地址',
        'msg12': '請選擇送達時間',
        'noCoupon': '暫無優惠券可用',
        'noPacket': '暫無紅包可用',
        'zhang': '張',
        'ge': '個',
        'total': '總計',
        'man': '滿',
        'fare': '運費',
        'hu': '戶',
        'preferential': '購買優惠',
        'realAmount': '實付',
        'order': '訂單',
        'ma': '嗎',
        'confirm': '確定',
        'nowGo': '立即搶購',
        'hou': '後',
        'orgTel': '聯繫電話',
        'choseShop': '選擇自取門店',
      'selfTakeTime':'選擇自取時間',
      'canceMsg':'很抱歉，由於庫存不足，該訂單已被商家取消！',
      'failFeeback':'退款失敗，請與商家聯系',
      'backMag':'款項已退回到我的',
      'orderType':'凈菜',
      'readying':'準備',
      'noSelfTake':'該店不支持到店自取，請選擇送貨到家',
      'selectSelfTakeTime':'請選擇自取時間',
      'selectSendToTime':'請選擇送達時間'
    },
    detail: {
        'chef': '名廚',
        'intro': '名廚介紹',
        'title': '烹飪機設備專用',
        'num': '菜譜編號',
        'place': '產地',
        'expiration': '保質期',
        'spec': '規格',
        'cooking_time': '烹飪時間',
        'storage': '存儲條件',
        'cooking_steps': '烹飪步驟',
        'step1': '壹鍵烹飪',
        'step2': '分段烹飪',
        'hour': '小時',
        'second': '秒',
        'minute': '分鐘' 
    },
    menu: {
        'menu': '菜譜',
        'bind': '綁定設備',
        'buy': '購買',
        'cook': '烹飪',
        'num': '編號',
        'tip': '即將同步以下菜譜到烹飪機設備上',
        'meal': '餐單',
        'clear': '確定要清空菜籃嗎',
        'same': '即將同步餐單菜譜到烹飪機設備上',
        'first': '請先綁定設備',
        'foodsNum': '菜譜名字/編號'
    },
    order: {
        'total': '原價總計金額',
        'connect': '聯系商家',
        'send': '送達',
        'get': '收貨',
        'quhuo': '取貨',
        'num': '訂單號',
        'detail': '訂單明細',
        'msg1': '感謝您對我們的信任',
        'msg2': '請耐心等候商家發貨',
        'msg3': '我們正在路上，很快就能送達',
        'msg4': '期待再次光臨',
        'msg5': '感謝妳的信任，是否確認收貨',
        'start': '出發時間',
        'msg6': '等待商家發貨中...',
        'over': '超時',
        'bad': '過期',
        'tab1': '待發貨',
        'tab2': '待確認',
        'cardCenter': '領取中心',
        'getTime': '領取時間',
        'lingqu': '領取',
        'yue': '糧票明細',
        'yue1': '糧票',
        'zhanghu': '賬戶',
        'balance': '累計積分',
        'dian': '點',
        'phone': '電話',
        'onlineRecharge':'在綫購買',
      'selectMoney':'請選擇購買金額',
      'onlineBuy':'購買',
      'please':'請',
      'dan':'單',
      'NO':'號',
      'tips':'該時間段已過或預約取餐人數已滿，為免耽誤用餐時間，請提前預約！',
      'deliverTime':'估計送達時間為'
    },
    cart: {
        'chosen': '已選',
        'cart': '購物車'
    },
	stores:{
		'existing':'已為你優選以下門店',
		'theCurrent':'當前都市暫未開通服務，現時已開通以下門店',
		'browse':'上次瀏覽'
	}
}



// WEBPACK FOOTER //
// ./src/assets/i18n/tw.js